@if (
  {
    label: label(),
    textLabel: textLabel(),
    defaultCountry: defaultCountry(),
    placeholder: placeholder(),
    disableLabel: disableLabel(),
    readonly: readonly(),
    uniqueId: uniqueId(),
    preferredCountries: preferredCountries()
  };
  as STATE
) {
  <form-field
    class="phone-field"
    [class.phone-field--readonly]="phoneControl.disabled || STATE.readonly"
  >
    <label
      class="phone-field__label"
      [for]="STATE.uniqueId"
      [class.phone-field__label--hidden]="STATE.disableLabel"
      label
    >
      {{ STATE.label || 'Numéro de téléphone' }}
      @if (isControlRequired) {
        <span>*</span>
      }
    </label>

    <phone-number-field
      input-field
      [uniqueId]="STATE.uniqueId"
      [formControl]="phoneControl"
      [defaultCountry]="$any(STATE.defaultCountry) || 'CI'"
      [disableDefaultValidation]="disableDefaultValidation()"
      [readonly]="phoneControl.disabled || STATE.readonly"
      [placeholder]="STATE.placeholder || 'Entrez un Numéro de téléphone'"
      [preferredCountries]="$any(STATE.preferredCountries) ?? []"
      (blur)="handleBlur()"
    >
    </phone-number-field>

    <ng-content></ng-content>
  </form-field>
}
